export default __webpack_public_path__ + "static/media/image-xx99-mark-two.42ad246f.jpg";